import React from 'react';
import { ROUTER } from "../../config";
import styled from "styled-components";
import { Container } from '../UI';
import { SOCIAL_LINKS } from "../../config";
import { FormattedMessage } from "react-intl";
import { getCookiesPolicyLink, getPrivacyPolicyLink, getTermsLink } from "../../helpers";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { IconFacebook, IconInstagramm, IconTelegram, IconTwitter, IconVK } from "../social-icons";
import { ReactComponent as Linkedin } from '../social-icons/linkedin.svg';
import { isHOGDomain } from '../../comon/isHOGDomain';

const Footer = () => {
    const interfaceLang = useSelector<RootState>(store => store.interfaceLang)

    if (window.location.pathname === ROUTER.messenger) return null;

    return (
        <Styled.Footer hog={isHOGDomain()}>
            <Styled.Container>
                <Styled.Row>
                    <Styled.Col>
                        <Styled.NavItem hog={isHOGDomain()}>
                            <a href='https://app.passport.gg/privacy-policy' target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="footer.privacyPolicy" />
                            </a>
                        </Styled.NavItem>
                        <Styled.NavItem hog={isHOGDomain()}>
                            <a href='https://app.passport.gg/cookie-policy' target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="footer.cookiesPolicy" />
                            </a>
                        </Styled.NavItem>
                    </Styled.Col>
                    <Styled.Col>
                        <Styled.NavItem hog={isHOGDomain()}>
                            <a href='https://app.passport.gg/terms-of-use' target="_blank" rel="noopener noreferrer">
                                <FormattedMessage id="footer.termsOfUse" />
                            </a>
                        </Styled.NavItem>
                        <Styled.NavItem hog={isHOGDomain()}>
                            <a href='https://about.passport.gg/adminsupport'>
                                <FormattedMessage id="footer.support" />
                            </a>
                        </Styled.NavItem>
                    </Styled.Col>
                    <Styled.Col>
                        <Styled.SocialTitle hog={isHOGDomain()}>
                            <FormattedMessage id="footer.followUs" />
                        </Styled.SocialTitle>
                        <Styled.SocialLinks>
                            <Styled.SocialLink
                                target="_blank"
                                href={SOCIAL_LINKS.facebook}>
                                <IconFacebook />
                            </Styled.SocialLink>
                            <Styled.SocialLink
                                target="_blank"
                                href={SOCIAL_LINKS.instagram}>
                                <IconInstagramm />
                            </Styled.SocialLink>
                            <Styled.SocialLink
                                target="_blank"
                                href='https://www.linkedin.com/company/passportgg/'>
                                <Linkedin />
                                {/* <img src='data:image/png;base64,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' alt='linkedin'></img> */}
                                {/* <IconTwitter /> */}
                            </Styled.SocialLink>
                            {/* <Styled.SocialLink
                                target="_blank"
                                href={SOCIAL_LINKS.telegram}>
                                <IconTelegram />
                            </Styled.SocialLink> */}
                            {/* <Styled.SocialLink
                                target="_blank"
                                href={SOCIAL_LINKS.vk}>
                                <IconVK />
                            </Styled.SocialLink> */}
                        </Styled.SocialLinks>
                    </Styled.Col>
                </Styled.Row>
            </Styled.Container>
        </Styled.Footer>
    )
}

export const Styled = {
    Footer: styled.footer<any>`
    background: ${props => (props.hog ? '#1e181e' : '#201941')};
        padding: 32px 0;
    `,
    Container: styled(Container)``,
    Row: styled.div`
        display: flex;
        flex-wrap: wrap;
        margin: 0 -15px;
    `,
    Col: styled.div`
        width: 33.3333%;
        padding: 0 15px;
        
        @media (max-width: 991px) {
            width: 50%;
            
            &:last-child {
                width: 100%;
            }
        }

        @media (max-width: 767px) {
            width: 100%;
            
            &:nth-child(2) {
                margin-top: 16px;
            }
        }
    `,
    NavItem: styled.div<any>`

        @media (max-width: 991px) {
            text-align: center;
        }
            
        & + & {
            margin-top: 16px;
        }

        a {
            font-weight: 500;
            font-size: 14px;
            text-decoration: none;
            color: ${props => (props.hog ? '#d7bc33' : '#ffffff')};

            &:hover, &focus {
                text-decoration: underline;
            }
        }
    `,
    SocialTitle: styled.div<any>`
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        margin: 0 0 12px;
        text-align: center;
        color: ${props => (props.hog ? '#d7bc33' : '#ffffff')};

        @media (max-width: 991px) {
            margin-top: 32px;
        }
        
    `,
    SocialLinks: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    SocialLink: styled.a`
        width: 24px;
        height: 24px;
        opacity: .6;
        transition: opacity .3s ease;
        
        &:hover, &:focus {
            opacity: 1;
        }
        
        & + & {
            margin-left: 20px;
        }
    `,
    Copy: styled.div`
        margin: 16px 0 0;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        
        @media (max-width: 991px) {
            text-align: center;
        }
    `
}

export default Footer